import React from 'react';

console.log('✅✅✅ TEST CONSOLE - This file loaded!');
console.log('✅✅✅ TEST CONSOLE - If you see this, console.log is working!');

function TestConsole() {
  console.log('✅ TestConsole Component - Rendered at:', new Date().toISOString());
  
  return (
    <div style={{ padding: '20px', background: '#f0f0f0', margin: '20px' }}>
      <h1>Console Test Page</h1>
      <p>Open your browser console (F12) and check for messages with ✅ emoji</p>
      <p>If you see those messages, console.log is working!</p>
      <button onClick={() => console.log('✅ Button clicked!')}>
        Click to test console.log
      </button>
    </div>
  );
}

export default TestConsole;

